import styled from "styled-components";

const FnrPath = styled("path")`
  stroke-width: 0px;
  fill: ${({ $virtue, $color, theme: { palette, colors } }) =>
    palette.icon[$virtue] || palette[$color] || colors[$color] || $color};
`;

export default FnrPath;
